var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141px",
    height: "83px",
    viewBox: "0 0 141 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-Illo-1",
    transform: "translate(-650.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(652.000000, 318.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.201678,40.5740824 C119.998379,34.6237269 118.87383,28.1741392 115.169366,23.1829657 C111.464903,18.1917922 105.617372,15.2476152 99.4016781,15.2440824 C95.2167478,15.2446989 91.1429214,16.5909548 87.7816781,19.0840824 C80.4171962,4.66441304 64.1234838,-2.82162257 48.3855977,0.983820648 C32.6477116,4.78926386 21.5743626,18.8926938 21.6116781,35.0840824 C21.6104061,36.9938122 21.7676122,38.9003542 22.0816781,40.7840824 C21.1580276,40.6450657 20.2257016,40.5715489 19.2916781,40.5640824 C8.63810523,40.5640824 0.00167805269,49.2005096 0.00167805269,59.8540824 C0.00167805269,70.5076552 8.63810523,79.1440824 19.2916781,79.1440824 L117.351678,79.1440824 C127.823364,79.1291346 136.368572,70.7583703 136.599469,60.2892192 C136.830367,49.8200681 128.662523,41.0806973 118.201678,40.6040824 L118.201678,40.5740824 Z",
    id: "Path",
    fill: "#F4F8FC",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9716781,30.0240824 L21.8816781,30.7340824 L22.0816781,30.7340824 C22.0416781,30.5140824 22.0116781,30.2740824 21.9716781,30.0240824 Z",
    id: "Path",
    fill: "#17FFEF",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.561678,30.6140824 C118.561678,30.3640824 118.441678,30.1340824 118.381678,29.8940824 C118.321678,30.1240824 118.271678,30.3540824 118.201678,30.5740824 L118.561678,30.6140824 Z",
    id: "Path",
    fill: "#17FFEF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.351678,69.1140824 L19.2916781,69.1140824 C10.5665655,69.1126983 2.92988916,63.2518979 0.671678053,54.8240824 C-0.899883706,60.6171363 0.320755916,66.8117149 3.97254125,71.57551 C7.62432659,76.3393052 13.2892525,79.1270245 19.2916781,79.1142131 L117.351678,79.1142131 C123.356795,79.1362013 129.027122,76.3502877 132.679326,71.5833875 C136.331529,66.8164873 137.545806,60.6165313 135.961678,54.8240824 C133.704431,63.248309 126.073073,69.1081749 117.351678,69.1140824 Z",
    id: "Path",
    fill: "#A9DAFF",
    fillRule: "nonzero",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3D5772",
    fillRule: "nonzero",
    cx: 59.6116781,
    cy: 42.6040824,
    r: 2.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3D5772",
    fillRule: "nonzero",
    cx: 78.9916781,
    cy: 42.6040824,
    r: 2.42
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5716781,58.6540824 C76.4231388,54.5557711 73.0576803,51.3100806 68.9566781,51.3100806 C64.8556758,51.3100806 61.4902173,54.5557711 61.3416781,58.6540824",
    id: "Path",
    stroke: "#3D5772",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.201678,40.5740824 C119.998379,34.6237269 118.87383,28.1741392 115.169366,23.1829657 C111.464903,18.1917922 105.617372,15.2476152 99.4016781,15.2440824 C95.2167478,15.2446989 91.1429214,16.5909548 87.7816781,19.0840824 C80.4171962,4.66441304 64.1234838,-2.82162257 48.3855977,0.983820648 C32.6477116,4.78926386 21.5743626,18.8926938 21.6116781,35.0840824 C21.6104061,36.9938122 21.7676122,38.9003542 22.0816781,40.7840824 C21.1580276,40.6450657 20.2257016,40.5715489 19.2916781,40.5640824 C8.63810523,40.5640824 0.00167805269,49.2005096 0.00167805269,59.8540824 C0.00167805269,70.5076552 8.63810523,79.1440824 19.2916781,79.1440824 L117.351678,79.1440824 C127.823364,79.1291346 136.368572,70.7583703 136.599469,60.2892192 C136.830367,49.8200681 128.662523,41.0806973 118.201678,40.6040824 L118.201678,40.5740824 Z",
    id: "Path",
    stroke: "#3D5772",
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadCloud);
export default __webpack_public_path__ + "static/media/SadCloud.6b16c1c56c32c181248b1991704d5773.svg";
export { ForwardRef as ReactComponent };